import { Injectable } from '@angular/core';
import {
    CreateOrderFileInput,
    OrderFile,
    UpdateOrderFileInput
} from '@app/core/services/api/API.service';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
@Injectable({
    providedIn: 'root'
})
export class OrderFileService {
    private amplifyClient = generateClient();
    constructor() {}

    async listOrderFiles(): Promise<OrderFile[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderFiles
                })
            ).data.listOrderFiles.items;
            if (data) return data as OrderFile[];
        } catch (error) {
            console.error('Error finding OrderFile:', error);
            return null;
        }
    }

    async createOrderFile(input: CreateOrderFileInput): Promise<OrderFile> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderFile,
                    variables: {
                        input
                    }
                })
            ).data.createOrderFile;
            if (date) return date as OrderFile;
        } catch (error) {
            console.error('Error creating OrderFile:', error);
            return null;
        }
    }

    async createO(input: UpdateOrderFileInput): Promise<OrderFile> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderFile,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderFile;
            if (date) return date as OrderFile;
        } catch (error) {
            console.error('Error updated OrderFile:', error);
            return null;
        }
    }
}
